module.exports = __webpack_public_path__ + "img/lc04.cd41c8cb.png";